import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  Portal,
  Spacer,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
// import { CgKey, CgUserAdd } from 'react-icons/cg'
import RootStore from '../../store/RootStore'
import { useNavigate } from 'react-router-dom'
import CustomMenuList from './CustomMenuList/CustomMenuList'
import { SiOpenaccess } from 'react-icons/si'
import { MdForum } from 'react-icons/md'
import { AccessRole } from '../../types/AuthTypes'
import { AuthContext } from '../../contexts/AuthContext'

const clientMenuItems = (navigate, userAccess) =>
  [
    // {
    //   id: '1',
    //   label: 'Change password',
    //   icon: (
    //     <CgKey
    //       size={20}
    //       color="brand.textDarkBlue"
    //     />
    //   ),
    // },
    // {
    //   id: '2',
    //   label: 'Invite colleagues',
    //   icon: (
    //     <CgUserAdd
    //       size={20}
    //       color="brand.textDarkBlue"
    //     />
    //   ),
    // },
    {
      id: '3',
      label: 'PIN',
      action: () => {
        window.open('https://pin.cembenchmarking.com/', '_blank')
      },
      icon: (
        <MdForum
          size={20}
          color="brand.textDarkBlue"
        />
      ),
    },
    {
      id: '4',
      label: 'Manage Users',
      action: () => {
        window.open(
          'https://portal.cembenchmarking.com/Portal/UserAccess',
          '_blank'
        )
      },
      icon: (
        <SiOpenaccess
          size={20}
          color="brand.textDarkBlue"
        />
      ),
    },
  ].slice(0, userAccess === AccessRole.CemAdmin ? 4 : 3)

ProfileMenu.propTypes = {
  client: PropTypes.string,
}

function ProfileMenu({ client }) {
  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const handleLogoutClick = () => {
    let result = RootStore.authStore.logout()
    if (result) {
      logout()
    } else {
      alert('logout failed')
    }
  }

  const {
    authStore: { userAccess },
  } = RootStore
  return (
    <Menu>
      <Tooltip
        label={client}
        placement="bottom"
        openDelay={300}
        hasArrow
        bg="gray.700"
        isDisabled={client.length < 20} // Only show tooltip for long names
      >
        <MenuButton
          as={Button}
          rightIcon={
            <ChevronDownIcon
              borderLeft="1px solid"
              borderColor="brand.grayDivider"
              fontSize="20px"
              pl="4px"
            />
          }
          h={['30px', '30px', '70px']}
          minW={['120px', '120px', '180px']}
          maxW={['160px', '160px', '320px']}
          color="brand.textDarkBlue"
          bg="white"
          _active={{ bg: 'white' }}
          _hover={{ bg: 'white' }}
          marginRight={['20px', '20px', 'unset']}
          px={3}
          justifyContent="flex-start">
          <HStack
            overflow={'hidden'}
            width="100%"
            pr="2">
            <Text
              fontSize={['10px', '10px', '18px']}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="100%"
              maxWidth="100%"
              isTruncated>
              {client}
            </Text>
          </HStack>
        </MenuButton>
      </Tooltip>
      <Portal>
        <CustomMenuList items={clientMenuItems(navigate, userAccess)}>
          <MenuDivider
            m="16px 8px 0"
            color="brand.grayDivider"
          />
          <MenuGroup>
            <HStack p="16px">
              <Spacer />
              <Button
                onClick={handleLogoutClick}
                variant="link"
                fontSize="14px"
                color="brand.textDarkBlue">
                Logout
              </Button>
            </HStack>
          </MenuGroup>
        </CustomMenuList>
      </Portal>
    </Menu>
  )
}

export default React.memo(props => <ProfileMenu {...props} />)
